/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_duration_in_minutes17 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("en", i.count, {});
	if (countPlural == "one") return `${i.count} minute`;
	if (countPlural == "other") return `${i.count} minutes`;
	return "DURATION_IN_MINUTES";
};

const fr_duration_in_minutes17 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("fr", i.count, {});
	if (countPlural == "one") return `${i.count} minute`;
	if (countPlural == "other") return `${i.count} minutes`;
	return "DURATION_IN_MINUTES";
};

const de_duration_in_minutes17 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("de", i.count, {});
	if (countPlural == "one") return `${i.count} Minute`;
	if (countPlural == "other") return `${i.count} Minuten`;
	return "DURATION_IN_MINUTES";
};

const es_duration_in_minutes17 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("es", i.count, {});
	if (countPlural == "one") return `${i.count} minuto`;
	if (countPlural == "other") return `${i.count} minutos`;
	return "DURATION_IN_MINUTES";
};

const it_duration_in_minutes17 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("it", i.count, {});
	if (countPlural == "one") return `${i.count} minuto`;
	if (countPlural == "other") return `${i.count} minuti`;
	return "DURATION_IN_MINUTES";
};

const ar_duration_in_minutes17 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("ar", i.count, {});
	if (countPlural == "one") return `${i.count} دقيقة`;
	if (countPlural == "other") return `${i.count} دقيقة`;
	return "DURATION_IN_MINUTES";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const duration_in_minutes17 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.duration_in_minutes17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("duration_in_minutes17", locale)
	if (locale === "en") return en_duration_in_minutes17(inputs)
	if (locale === "fr") return fr_duration_in_minutes17(inputs)
	if (locale === "de") return de_duration_in_minutes17(inputs)
	if (locale === "es") return es_duration_in_minutes17(inputs)
	if (locale === "it") return it_duration_in_minutes17(inputs)
	return ar_duration_in_minutes17(inputs)
};
export { duration_in_minutes17 as "DURATION_IN_MINUTES" }